import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import { GetLoadingTermsRequestQuery, LoadingTermsResponseData } from "../types/order"
import api from "../client"

const getData = async ({ countryCode, date }: GetLoadingTermsRequestQuery) => {
  const { data } = await api.get(`/loadings/terms/${countryCode}/${date}`)
  return data
}

export const useLoadingTerms = (
  getLoadingTermsQueryParams: GetLoadingTermsRequestQuery,
  isOrderEditable: boolean
): QueryObserverBaseResult<LoadingTermsResponseData> => {

  const { countryCode, date } = getLoadingTermsQueryParams

  const { data, ...props } = useQuery<LoadingTermsResponseData>(
    queryKeys.LOADING_TERMS(getLoadingTermsQueryParams),
    () => getData(getLoadingTermsQueryParams),
    { enabled: Boolean(countryCode && date && isOrderEditable) }
  )

  return { data, ...props }
}
